// Define the type for the element being added
interface Element {
    id: string;
    type: string;
    name: string;
    opacity: number;
    visible: boolean;
    selectable: boolean;
    removable: boolean;
    alwaysOnTop: boolean;
    showInExport: boolean;
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
    animations?: any[];
    draggable?: boolean;
    resizable?: boolean;
    contentEditable: boolean;
    styleEditable: boolean;
    text: string;
    fontSize: number;
    fontFamily: string;
    fontStyle: string;
    fontWeight: string;
    fill: string;
    align: string;
    verticalAlign: string;
    lineHeight: number;
    letterSpacing: number;
    backgroundEnabled?: boolean;
    backgroundColor?: string;
    backgroundOpacity?: number;
    backgroundCornerRadius?: number;
    backgroundPadding?: number;
}

// Define the type for the page
interface Page {
    addElement: (element: Element) => void;
}

// Define the type for the store
interface Store {
    pages: Page[];
    history: {
        clear: () => void;
    };
}

// Reusable function to create text elements
const createTextElement = (
    id: string,
    text: string,
    x: number,
    y: number,
    width: number,
    rotation: number = 0
): Element => ({
    id,
    type: "text",
    name: "",
    opacity: 1,
    visible: true,
    selectable: false,
    removable: false,
    alwaysOnTop: true,
    showInExport: true,
    x,
    y,
    width,
    height: 11,
    rotation,
    draggable: false,
    resizable: true,
    contentEditable: true,
    styleEditable: false,
    text,
    fontSize: 7,
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fill: "black",
    align: "center",
    verticalAlign: "top",
    lineHeight: 1.2,
    letterSpacing: 0,
});


export const addIdentifierAreaToSnapPackMailer = (store: Store): void => {
    const pageTwo = store.pages[1];

    const elements: Element[] = [
        createTextElement("cont-id-placeholder", "C:", 219.5, 389, 11, 180),
        createTextElement("contId", "0000001", 211.2, 389, 30, 180),
        createTextElement("sequence-id-placeholder", "| S:", 183.34, 389, 12, 180),
        createTextElement("sequence", "0000001", 171.34, 389, 29, 180),
        createTextElement("template-id-placeholder", "| T:", 145.34, 389, 14, 180),
        createTextElement("templateId", "0001034", 134, 389, 29, 180),
        createTextElement("order-id-placeholder", "| O:", 105, 389, 11, 180),
        createTextElement("orderId", "0000127", 94, 389, 29, 180),
    ];

    elements.forEach(element => pageTwo.addElement(element));
    store.history.clear();
};